/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Step_PaywallInputs */

const en_admin_funnel_step_paywall = /** @type {(inputs: Admin_Funnel_Step_PaywallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saw paywall`)
};

/**
* | output |
* | --- |
* | "Saw paywall" |
*
* @param {Admin_Funnel_Step_PaywallInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_step_paywall = /** @type {((inputs?: Admin_Funnel_Step_PaywallInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Step_PaywallInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_step_paywall(inputs)
});
export { admin_funnel_step_paywall as "admin.funnel.step.paywall" }